export class UserDetails {

    constructor(public associatedApps: string,
        public email: string, public firstName: string,
        public lastName: string, public telephoneNumber: string,
        public userId: string, public userName: string,
        public userPassword: string, public userStatus: string) {
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/userManagement/user-details.ts
 **/